
import { useCustomMutation } from '@refinedev/core';
import gql from 'graphql-tag';
import { useGoogleAccounts } from 'hooks/google/useGoogleApi';
import { useGoogleIsAuthenticated } from './useGoogleAuthenticated';
import { useQueryClient } from '@tanstack/react-query';
import { ACCESS_TOKEN_QUERY_KEY } from '@auth/definitions';

export const useGoogleConnect = () => {
    const { data: auth } = useGoogleIsAuthenticated()
    const { mutateAsync: saveRefreshToken } = useCustomMutation()
    const [tokenClient] = useGoogleAccounts()
    const queryClient = useQueryClient();

    const handler = () => {
        if (!tokenClient) return
        tokenClient.callback = async (tokenResponse: any) => {
            if (tokenResponse.error !== undefined) {
                throw (tokenResponse);
            }

            // logger.debug(tokenResponse)

            await saveRefreshToken({
                url: '',
                method: 'post',
                values: {},
                meta: {
                    gqlMutation: gql`mutation SaveRefreshToken($refresh_token: String!) {
                        save_refresh_token(refresh_token: $refresh_token) {
                          saved
                        }
                      }
                      `,
                    gqlVariables: {
                        refresh_token: tokenResponse.code,
                    }
                }
            })
            await queryClient.invalidateQueries([ACCESS_TOKEN_QUERY_KEY]);
        };

        tokenClient.requestCode()
    }

    return [handler, auth.authenticated] as [() => void, boolean]
}